import { Component, OnInit,ViewChild } from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { isNullOrUndefined } from 'util';
import { PreviewfileUploadComponent } from 'src/app/common/ngbmodel/previewfile-upload/previewfile-upload.component';


@Component({
  selector: 'app-uploadconsolidate-meeting-reports',
  templateUrl: './uploadconsolidate-meeting-reports.component.html',
  styleUrls: ['./uploadconsolidate-meeting-reports.component.css']
})
export class UploadconsolidateMeetingReportsComponent implements OnInit {
  @ViewChild('submitModal',{})submitModal;
  editweightfilter: object = {'ay':"",'lu':"","month":""};
  validation: boolean[] = new Array(3).fill(true);
  exceluploadData : object = {'excelFile':null};
  yearDropDownList: any;
  activeSpinner:boolean;
  monthList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  monthvalues = ['04','05','06','07','08','09','10','11','12','01','02','03'];
  parseobj:any;
  monthsList: any;
  statelists: any[];
  modelRef : any;
  outputerror: string;
  wrongFileCheck: boolean;
  userdetails: any;
  selectedFiles=null;
  fileuploadData: any;
  dateofSubmission: any;
  eventHandle: any;
  modalReference: any;
  fetchReport:any;
  showtabledata:boolean=false;
  constructor(public tableconstants : TableConstantsModule,
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private modalService: NgbModal,
    private logsrv : AuthloginService,
    private toastr : ToastrService,) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    this.userdetails = this.logsrv.checkloginstatus();
    this.monthsList = this.monthList;
    this.setCurrentMonthDefault();
    this.getstateslist();

  }
  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });
        this.editweightfilter['ay'] = dropDownYear;
  }
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.editweightfilter['month'] = currentmonthObj['key'];
  }
  getstateslist(){
    let postdata = {};
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
        //  this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            if(statelist['uuid'] == this.userdetails.loggedUserData.userProfile.stateUUID){
              this.statelists.push(statelist);
              // console.log('statelists',this.statelists);
              this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
          });
        })
      }
    });
  
  }
  filechoosen(event){
    this.eventHandle = event;
    this.outputerror = '';
    if(event.target.files.length > 0) 
    {
      if(this.checkTypeOfFile(event.target.files[0].name)){
       this.selectedFiles = event.target.files[0];
      }else{
        this.selectedFiles = null;
      }
    }else{
      this.selectedFiles = null;
    }
  }
  fetchtableData(){
      this.showtabledata = true;
      let postdata ={
          "ay": this.editweightfilter['ay'],
          "subTp": JSON.stringify(this.monthvalues),//this.editweightfilter['month'],
          "ts": new Date().getTime(),
          "pu": "f78f615d-e270-4f93-90ac-27608e756b85",
          "userId": this.userdetails['loggedUserData']['userProfile']['userId'],
          "view": "admin",
          "component": 1,
          "cType": this.constants.LOCATION_CONSTANT.STATE
      }
      this.submitdataSerivce.fetchConsolidatedMeetingReport(postdata).subscribe(data=>{
        if(!isNullOrUndefined(data)){
          this.fetchconsolidatedReports(data);
        }
      })
}
formatDate(inputDate : any){
  if(inputDate != String){
    inputDate = inputDate.toString();      
  }
  let year = inputDate.substring(0,4);
  let month = inputDate.substring(4,6);
  let date = inputDate.substring(6,8);
  let monthLabl;
  if(inputDate.length == 6){      
  this.monthsList.forEach(mon => {
    if(month == mon['key']){          
      monthLabl = mon['value'];          
    }
  });      
  // if(month == '04' || month == '05'){
  //   year1 = year-1;        
  // }
  // let newDate = monthLabl + "-" + year1;         
  return monthLabl;
  } else{
  let newDate = date + "-" + month +"-" + year;
  return newDate;
  }
}

fetchconsolidatedReports(data){
    // console.log('userdetails',this.userdetails);
    // console.log('editweight filter',this.editweightfilter);
    // console.log('statelists[0]',this.statelists[0]['name']);
    this.fetchReport =[];
    if(!isNullOrUndefined(data)){
      this.statelists.forEach(obj=>{
        let tabledata=[];
        Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
              if(key == obj['uuid']){
                this.parseobj = value;
                Object.keys(this.parseobj).forEach(month=>{
                  let parseArray=JSON.parse(this.parseobj[month]);
                  let item ={};
                  if(parseArray!=null){
                    item['stateName'] = obj['name'];
                    item['fileuuid'] = parseArray['fileUUID'];
                    item['date'] = this. formatDate(parseArray['dateofSubmission']);
                    this.fetchReport.push(item);
                  }
                  // tabledata.push(item);
                })
              } 
          })
      })
      // console.log("fetch",this.fetchReport);
      
    //   if(this.userdetails['login'] == "sgc_bh"){
    //     Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
    //       if(key == "BIHAR"){
    //         this.parseobj = value;
    //         let parseArray = JSON.parse(this.parseobj);
    //         let item ={};
    //         if(this.parseobj!=null){
    //           item['stateName'] = key;
    //           item['uuid'] = parseArray['fileUUID'];
    //           item['date'] = this. formatDate(parseArray['dateofSubmission'])
    //           this.fetchReport.push(item);
    //         }
    //       }
    //     })
    //   } else if(this.userdetails['login']=="sgc_uk"){
    //     this.statelists.forEach(obj=>{
    //         let tabledata=[];
    //         Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
    //               if(key == obj['uuid']){
    //                 this.parseobj = value;
    //                 Object.keys(this.parseobj).forEach(month=>{
    //                   let parseArray=JSON.parse(this.parseobj[month]);
    //                   let item ={};
    //                   if(parseArray!=null){
    //                     item['stateName'] = obj['name'];
    //                     item['fileuuid'] = parseArray['fileUUID'];
    //                     item['date'] = this. formatDate(parseArray['dateofSubmission']);
    //                     this.fetchReport.push(item);
    //                   }
    //                 })
    //               } 
    //           })
    //       })
    //    } else if(this.userdetails['login'] == "sgc_up"){
    //     Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
    //       if(key == "UTTAR PRADESH"){
    //         this.parseobj = value;
    //         let parseArray = JSON.parse(this.parseobj);
    //         let item ={};
    //         if(this.parseobj!=null){
    //           item['stateName'] = key;
    //           item['uuid'] = parseArray['fileUUID'];
    //           item['date'] = this. formatDate(parseArray['dateofSubmission'])
    //           this.fetchReport.push(item);
    //         }
    //       }
    //     })
    //   } else if(this.userdetails['login'] == "sgc_wb"){
    //     Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
    //       if(key == "WEST BENGAL"){
    //         this.parseobj = value;
    //         let parseArray = JSON.parse(this.parseobj);
    //         let item ={};
    //         if(this.parseobj!=null){
    //           item['stateName'] = key;
    //           item['uuid'] = parseArray['fileUUID'];
    //           item['date'] = this. formatDate(parseArray['dateofSubmission'])
    //           this.fetchReport.push(item);
    //         } 
    //       }
    //     })
    //   } else if(this.userdetails['login'] == "sgc_jh"){
    //     Object.entries(data[this.editweightfilter['ay']]).forEach(([key,value]) =>{
    //       if(key == "JHARKHAND"){
    //         this.parseobj = value;
    //         let parseArray = JSON.parse(this.parseobj);
    //         let item ={};
    //         if(this.parseobj!=null){
    //           item['stateName'] = key;
    //           item['uuid'] = parseArray['fileUUID'];
    //           item['date'] = this. formatDate(parseArray['dateofSubmission'])
    //           this.fetchReport.push(item);
    //         }
    //       } 
    //     })
    //   }
    }
  }
  public checkTypeOfFile(filename){
    filename = filename.split('.');
    if(filename[filename.length-1] === 'pdf'){
      return true;
    }else{
      return false;
    }
  }
  changeMonth(){
    this.selectedFiles = null;
  }
  CloseWindowModal(){
    this.modalReference.dismiss();
    this.selectedFiles = null;
    
  }
  fileValidation() {
    this.wrongFileCheck = false;
    let fileInput = document.getElementById('filemeeting');
    let filePath = fileInput['value'];
    let allowedExtensions = /(\.pdf)$/i;
    if (!allowedExtensions.exec(filePath)) {
      this.wrongFileCheck = true;
      this.toastr.error(('Please upload file having extensions .pdf only.'));
      fileInput['value'] = '';
      return false;
    } else {
      this.toastr.success(('Correct File Selected'));
      return true;
    }
  }
  submitPopupModal(){
    let postData = {};
    postData[this.userdetails.loggedUserData.userProfile.locationId] =  this.selectedFiles;
    this.submitdataSerivce.uploadFile(postData).subscribe(data=>{
    if(!isNullOrUndefined(data)){
      this.fileuploadData = data.data;
      this.submitFile();
    }
    });
  }
  previewFileUpload(){
  let originalFile = this.eventHandle.target.files[0];
  let reader = new FileReader();
  reader.readAsDataURL(originalFile);
  reader.onload = () => {
    // let json = JSON.stringify({ dataURL: reader.result });
    // let fileURL = JSON.parse(json).dataURL;
    let myNode =  document.getElementById("pdf_file")
    while (myNode.firstChild) {
      myNode.removeChild(myNode.firstChild);
  }

    let originalFileURL = URL.createObjectURL(originalFile);
  //     document.getElementById("pdf_file").insertAdjacentHTML('afterend',`<object data="${originalFileURL}"
  //   type="application/pdf" width="500px" height="600px">
  // </object>`);

  document.getElementById("pdf_file").insertAdjacentHTML('afterend',`<iframe src="${originalFileURL}"
   type="application/pdf" width="500px" height="600px" style="overflow: auto;">
  </iframe>`);
      URL.revokeObjectURL(originalFileURL);
    };
  
    this.modelRef = this.modalService.open(PreviewfileUploadComponent,{windowClass:'modal-dialog-centered', centered:true});
  }
  openUploadWindow(){
    if(this.Basicvalidation()){
      this.modalReference = this.modalService.open(this.submitModal,{windowClass:'submit-modal-centered'});
      this.modalReference.result.then((result) => {
      }, (reason) => {
      });
    } else{
      this.toastr.error("please select document for uploading")
    }
  }
  public Basicvalidation():boolean{
    this.validation[0] = this.utils.checkfields(this.selectedFiles);
    return this.validation[0];
   } 
  // virt
  submitFile(){
    let  rfdate = new Date();
    let date1 = rfdate.setDate(rfdate.getDate());
    this.dateofSubmission = this.utils.getDateandTimeString(date1,"YYYYMMDD");
    this.activeSpinner = true;
    let uploadData ={
      "ay": this.editweightfilter['ay'],
      "subTp": this.editweightfilter['month'],
      "data": JSON.stringify({"dateofSubmission":this.dateofSubmission,"fileUUID":this.fileuploadData[this.userdetails.loggedUserData.userProfile.locationId]}),
      "ts":new Date().getTime(),
      "lu": this.userdetails.loggedUserData.userProfile.locationId,
      "userId": this.userdetails['loggedUserData']['userProfile']['userId'],
      "view": "admin",
      "component": 1,
      "cType": this.constants.LOCATION_CONSTANT.STATE
    }
    this.submitdataSerivce.fetchuploadData(uploadData).subscribe(result=>{
        if(result){
        this.toastr.success(result.msg);
        this.selectedFiles = "";
        this.modalReference.dismiss();
        this.activeSpinner = false;
      } else{
        this.toastr.error(result.msg)
      }
    })
  }

  downloadConsolidatedReport(uuid){
    let data ={
      "fileUUID" : uuid
    }    
    this.activeSpinner = true;
    this.submitdataSerivce.downloadExcel(data).subscribe(data=>{
      this.activeSpinner = false;
      let filename: string =  "ConsolidatedReportSummary";
      var newBlob = new Blob([data], { type: "application/pdf" });
      const result = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = result;
      link.download = filename;
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
          window.URL.revokeObjectURL(data);
          link.remove();
      }, 100);
    });
  }

  removechosenfile(){
    this.selectedFiles = null;
  }

}
